import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    clientData: {},
    requirements: [],
    venueShortlist: [],
    supplierShortlist: [],
    timeDetails: [],
    FunctionSheetEmailData:null,
    hasAssigneeChanged:false
};

 const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    eventDetails:(state,action)=>{
        state.clientData=action.payload
      },
      setAllEventData: (state, action) => {
        return { ...state, ...action.payload };
      },
    updateAssignee:(state,action)=>{
      state.hasAssigneeChanged=action.payload
    },
      clearEventData: () => initialState,
      setFunctionSheetMailData: (state, action) => {
        state.FunctionSheetEmailData = action.payload;
      },
  },
});

export const {eventDetails,setAllEventData, clearEventData,setFunctionSheetMailData,updateAssignee} = eventSlice.actions;

export default eventSlice.reducer;
